<template>
  <div>
    <vxe-table ref="table" :data="data" :edit-config="{}" :loading="loading" keep-source>
      <vxe-column :type="selectType" fixed="left" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="200"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="200"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="50"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="lot.no" title="business.label.lot" width="150"/>
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150"/>
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="container.no" title="business.label.containerNo" width="90"/>
      <vxe-column field="command.allocateQuantity" title="business.label.allocateQuantity" width="150"/>
      <vxe-column v-if="!stereoscopic" field="allocateLocation.no" title="business.label.allocateLocation" width="100"/>
      <vxe-column v-if="!stereoscopic" field="command.putawayQuantity" fixed="right" title="business.label.putawayQuantity" width="150">
        <template #edit="{ row }">
          <vxe-number-input v-model="row.command.putawayQuantity" :max="row.command.allocateQuantity" :min="1"/>
        </template>
      </vxe-column>
      <vxe-column v-if="!stereoscopic" field="storageRoom.name" fixed="right" title="business.label.targetStorageRoom" width="120">
        <template #edit="{ row }">
          <vxe-input v-model="row.storageRoom.name" :editable="false" @clear="onStorageRoomChange([],row)" @click="onStorageRoomSelect(row)"/>
        </template>
      </vxe-column>
      <vxe-column v-if="!stereoscopic" field="putawayLocation.no" fixed="right" title="business.label.putawayLocation" width="120">
        <template #edit="{ row }">
          <vxe-input v-model="row.putawayLocation.no" :editable="false" @clear="onLocationChange([],row)" @click="onLocationSelect(row)"/>
        </template>
      </vxe-column>
    </vxe-table>
    <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
    <StorageRoomModal ref="storageRoomModal" @change="onStorageRoomChange"/>
    <LocationModal ref="locationModal" @change="onLocationChange"/>
  </div>
</template>

<script>
import { findAll, post } from '@/api/Api'
import api from '@/api'
import StorageRoomModal from '@/views/modal/StorageRoomModal.vue'
import LocationModal from '@/views/modal/LocationModel.vue'
import { StorageRoom } from '@/api/dto/common/StorageRoom'
import { Location } from '@/api/dto/common/Location'

export default {
  components: { StorageRoomModal, LocationModal },
  props: {
    args: { type: Object, default: null },
    selectType: { type: String, default: 'checkbox' },
    stereoscopic: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      data: [],
      commandStatusData: [],
      page: 1,
      size: 15,
      contentSize: 0
    }
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    onStorageRoomSelect(row) {
      if (!this.automatic) {
        const args = { physical: true }
        this.$refs.storageRoomModal.open(args, row)
      }
    },
    onStorageRoomChange(values, row) {
      row.storageRoom = new StorageRoom(values[0])
      row.putawayLocation = new Location()
    },
    onLocationSelect(row) {
      if (row.storageRoom === undefined || row.storageRoom === null || row.storageRoom.id === null) {
        this.$message.warning('请先选择目标库房')
      } else {
        const args = { available: true, locking: false, mechanicalLocking: false, 'storageRoom.id': row.storageRoom.id }
        this.$refs.locationModal.open(args, row)
      }
    },
    onLocationChange(values, row) {
      row.putawayLocation = new Location(values[0])
    },
    fetch(args) {
      this.loading = true
      args = {
        ...args,
        inspected: true,
        commandStatusRange: { start: 'GENERATED', end: 'PUTAWAY_OBTAINED' }
      }
      if (args.range.length > 0) {
        args['commandDateFilter'] = { start: args.range[0], end: args.range[1] }
      } else {
        args['commandDateFilter'] = null
      }
      findAll('receiptCommandFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    refresh(args) {
      this.page = 1
      this.fetch(args)
    },
    reset() {
      this.data = []
    },
    putaway() {
      const selectRows = this.selectType === 'radio' ? [this.$refs.table.getRadioRecord()] : this.$refs.table.getCheckboxRecords()
      if (selectRows.length === 0) {
        return this.$message.warning('请选择需要上架的指令')
      }
      this.loading = true
      const args = selectRows.map(item => {
        return { id: item.command.id, putawayQuantity: item.command.putawayQuantity, putawayLocation: item.putawayLocation }
      })
      post(api.receivingReceiverCommandsPutaway, {}, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    review() {
      const selectRows = this.selectType === 'radio' ? [this.$refs.table.getRadioRecord()] : this.$refs.table.getCheckboxRecords()
      if (selectRows.length === 0) {
        return this.$message.warning('请选择复核的指令')
      }
      this.loading = true
      const args = { 'container.no': selectRows[0].container.no, passed: true }
      post(api.receivingReceiverReview, {}, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    },
    reject() {
      const selectRows = this.selectType === 'radio' ? [this.$refs.table.getRadioRecord()] : this.$refs.table.getCheckboxRecords()
      if (selectRows.length === 0) {
        return this.$message.warning('请选择复核不通过的指令')
      }
      this.loading = true
      const args = { 'container.no': selectRows[0].container.no, passed: false }
      post(api.receivingReceiverReview, {}, args).then(res => {
        if (res.success) {
          this.$message.success(this.$t('message.operationSuccess'))
          this.fetch()
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>